<template>
    <div class="header-page">
        <div class="header-left">
            <img class="logo-img" :src="srcUrl"/>
            <span>星程智能-商户车辆运营系统</span>
        </div>
         <div class="header-right">
               欢迎，
                <div class="company-name">{{company}}</div>
               <el-dropdown>
               <div class="account-name">{{nickname}}</div>
               <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                        <span @click="onPassword">修改密码</span>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <span @click="onLoginOut">退出</span>
                    </el-dropdown-item>
               </el-dropdown-menu>
            </el-dropdown>
            <PasswordForm :visible="visible" @onHidden="onHidden"/>
         </div>
    </div>
</template>
<script>
// import Cookies from 'js-cookie'
import {clearCache,getCache} from '@/utils'
import PasswordForm from '../password-form'
import srcUrl from '@/assets/logo.png'

export default {
    name:"headerPage",
    components:{
        PasswordForm
    },
    data(){
        return {
            srcUrl,
            visible:false,
            nickname:"",
            company:"",
        }
    },
    created(){
        this.nickname = getCache('xczn_merchant_nickname')
        this.company = getCache('xczn_merchant_company')
    },
    methods:{
        onPassword(){
            this.visible = true
        },
        onHidden(){
            this.visible= false
        },
        onLoginOut(){
            this.$confirm('您确定是否要退出登录?', '系统提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                clearCache("xczn_merchant_token")
                clearCache("xczn_merchant_nickname")
                clearCache("xczn_merchant_level")
                // const hostUrl = window.location.host
                // const domain = hostUrl.slice(hostUrl.indexOf("."),100)
                // Cookies.remove('xczn_merchant_token',{domain:domain})
                this.$router.push({path:"/login"})
            }).catch(() => {
                   
            });
        }
    }
}
</script>
<style scoped>
.header-page{
    height: 56px;
    border-bottom:1px solid #ebebeb;
    box-sizing: border-box;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
}
.header-left{
    font-family: AlibabaPuHuiTi;
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0em;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.header-right{
    display: flex;
    align-items: center;
    justify-content:flex-end;
    font-size: 14px;
}
.company-name{
    margin-right: 8px;
}
.account-name{
    cursor: pointer;
    color:#66b1ff;
}
.logo-img{
    width:50px;
    height:50px;
    margin-right:8px;
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue